import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e3a16700&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e3a16700&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=e3a16700&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a16700",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3a16700')) {
      api.createRecord('e3a16700', component.options)
    } else {
      api.reload('e3a16700', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e3a16700&scoped=true", function () {
      api.rerender('e3a16700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/designCategory/components/FormPage/index.vue"
export default component.exports